import { render, staticRenderFns } from "./truckingPage.vue?vue&type=template&id=3b745ba1&scoped=true&"
import script from "./truckingPage.vue?vue&type=script&lang=js&"
export * from "./truckingPage.vue?vue&type=script&lang=js&"
import style0 from "./truckingPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./truckingPage.vue?vue&type=style&index=1&id=3b745ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b745ba1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b745ba1')) {
      api.createRecord('3b745ba1', component.options)
    } else {
      api.reload('3b745ba1', component.options)
    }
    module.hot.accept("./truckingPage.vue?vue&type=template&id=3b745ba1&scoped=true&", function () {
      api.rerender('3b745ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Warehouse/truckingPage.vue"
export default component.exports